<template>
    <div class="page-user-lsit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">活動</div>
            <div class="breadcrumb-item">活動列表</div>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <div class="pg-btn style1" @click="handleToAdd">新增</div>
                </div>
            </div>
            <Table size="small"
                   no-data-text="暫無數據"
                   border
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="status">
                        <Switchs true-color="#51f4a9" v-model="row.status" @on-change="statusChange(row)"/>
                </template>

                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(row)">修改</div>
                        <!-- <div class="pg-btn style1" @click="handleDelete(row)">删除</div> -->
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>
    </div>
</template>

<script>
   export default {
      data() {
         return {
            srcList: [],
            pageIndex: 1,   //页码
            curPageSize: 10,    //一页数量
            pageInput: '',  //输入的页码
            isSubmiting: false,
            totalCount: 0,
            status: false, // 是否開啓
            table: {
               column: [
                  {
                     title: '活動ID',
                     key: 'id',
                     align: 'center',
                     sortable: true,
                     minWidth: 100
                  },
                  {
                     title: '活動名稱',
                     key: 'title',
                     align: 'center',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '是否開啓',
                     key: 'status',
                     align: 'center',
                     slot: 'status',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '參與總次數',
                     key: 'frequency',
                     align: 'center',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '參與總人數',
                     key: 'user_number',
                     align: 'center',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '更新時間',
                     key: 'created_at',
                     align: 'center',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '操作',
                     slot: 'action',
                     align: 'center',
                     minWidth: 100
                  }
               ],
               data: []
            }
         };
      },
      mounted() {
         this.getList();
      },
      methods: {
         /*
         * 是否開啓通知
         * */
         handlesrcList(imgobj){
            this.srcList = [];
            for (let i = 0; i < imgobj.length; i++)
            {
                this.srcList.push(imgobj);
            }
         },
         statusChange(item) {
            let id = item.id;
            let status;
            if (item.status == true) {
               status = 1;
            }else {
               status = 2;
            }
            this.isSubmiting = true;

            this.$Rq.requestAuth({
               url: this.$Api.eventActivityUpdate + '/' + id,
               method: 'post',
               data: {
                status_id: id,
                status: status,
               }
            }).then((res) =>
            {
               this.isSubmiting = false;
               this.getList();
               if (res.code == 0)
               {
                  this.$Utils.showSuccess(res.msg);
               } else
               {
                  this.$Utils.showTipInfo(res.msg);
               }
            }).catch((err) =>
            {
               this.isSubmiting = false;
            });
         },
         getList() {
            let form = this.form;
            this.isSubmiting = true;
            this.$Rq.requestAuth({
               url: this.$Api.eventActivityList,
               method: 'get',
               data: {
                  offset: (this.pageIndex - 1) * this.curPageSize,
                  limit: this.curPageSize,
               }
            }).then((res) => {
               this.isSubmiting = false;
               if (res.code == 0) {
                  let tempArr = [];
                  let resData = res.data;
                  for (let i = 0; i < resData.length; i++) {
                     let status;
                     if (resData[i].status == 1){
                        status = true;
                     } 
                     else if (resData[i].status == 0){
                        status = false;
                     }

                     tempArr.push({
                        id: resData[i].id,
                        title: resData[i].title,
                        user_number: resData[i].user_number,
                        status,
                        frequency: resData[i].frequency,
                        created_at: resData[i].created_at,
                     });
                  }
                  this.totalCount = res.data.count;
                  this.table.data = tempArr;
               } else {
                  this.showTipInfo(res.msg);
               }
            }).catch((err) => {
               this.isSubmiting = false;
            });
         },
         // handleDelete(item) {
         //    let id = item.id;
         //    this.$Modal.confirm({
         //       title: '提示',
         //       content: '確定刪除嗎？',
         //       cancelText: '取消',
         //       okText: '確定',
         //       onOk: () => {
         //          let tableData = this.table.data;
         //          this.isSubmiting = true;
         //          this.$Rq.requestAuth({
         //             url: this.$Api.appNotificationManageDel + `/${id}`,
         //             method: 'post'
         //          }).then((res) => {
         //             this.isSubmiting = false;
         //             if (res.code == 0) {
         //                this.$Utils.showSuccess(res.msg);
         //                this.getList();
         //             } else {
         //                this.$Utils.showTipInfo(res.msg);
         //             }
         //          }).catch((err) => {
         //             this.isSubmiting = false;
         //          });
         //       }
         //    });
         // },
         handleToAdd() {
            this.$router.push({path: '/eventListAdd'});
         },
         handleSearch() {
            this.pageIndex = 1;
            this.getList();
         },
         handleEdit(item) {
            this.$router.push({path: '/eventListEdit?id=' + item.id})
         },
         handlePageSizeChange(value) {
            this.pageIndex = 1;
            this.getList();
         },
         handlePageInput() {
            let value = ('' + this.pageInput).replace(/\D/g, '');
            let pageCount = Math.ceil(this.totalCount / this.curPageSize);
            if (value > pageCount) {
               value = pageCount;
            }
            this.pageInput = value;
         },
         handlePageEnter() {
            if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
            if (this.pageInput == 0) {
               this.pageInput = 1;
            }
            this.pageInput = parseInt(this.pageInput);
            this.pageIndex = this.pageInput;
            this.getList();
         },
         handlePageChange(value) {
            this.pageIndex = value;
            this.getList();
         }
      }
   };
</script>

<style lang="scss" scoped>
    @import 'eventList.scss';
</style>